import { styled } from '@mui/material/styles';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import Box from '@mui/material/Box';
import { gutterSmAndUp, maxWidth } from '@style/variables';
import isPropValid from '@emotion/is-prop-valid';

export const Section = styled('section')`
  position: relative;
  overflow: hidden;
`;

export const VerticalCarouselGallery = styled('div')`
  position: fixed;
  width: 100%;
  height: 100vh;
  bottom: 0;
  left: 0;
  pointer-events: none; /* Disable pointer events by default */

  /* But enable them for interactive elements */
  button,
  a,
  [role='button'] {
    pointer-events: auto;
  }
`;

export const VerticalCarouselGalleryItem = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity 0.4s ease-out;
`;

export const CarouselOverlay = styled('div')`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: black;
  opacity: 0;
`;

interface Props {
  textAlignRight: boolean;
}

export const VerticalCarouselItem = styled('div', { shouldForwardProp: isPropValid })<Props>`
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: ${(props) => (props.textAlignRight === true ? 'flex-end' : 'flex-start')};
  align-items: center;
  position: relative;
  z-index: 100;
`;

export const VerticalCarouselItemsContainer = styled('div')(
  ({ theme }) => `
    z-index: 98;
    max-width: ${maxWidth};
    margin: 0 auto;
    .vertical-carousel-item:first-of-type {
      margin-top: 40vh;
    }
    .vertical-carousel-item {
      margin-top: 60vh;
    }
    .vertical-carousel-item:last-of-type {
      margin-bottom: 40vh;
    }
      ${theme.breakpoints.up('md')} {
        padding: ${gutterSmAndUp};
      },
  `,
);

export const VerticalCarouselContent = styled('div')`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  max-width: 25rem;
  & .bottom-content {
    max-width: 354px;
  }
`;

export const Image = styled(LazyLoadImage)`
  overflow: hidden;
  height: 100%;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    overflow: hidden;
  }
`;

export const VideoWrapper = styled('div')`
  & div {
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100vh;
    & video {
      width: 100% !important;
    }
  }
`;
